import axios from 'axios'
import Vue from 'vue'

const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_URL
})

request.interceptors.request.use(
  (config) => {
    let token = window.localStorage.getItem('token') // 获取token
    token && (config.headers.Authorization = token) // 添加头部信息token 键名为Authorization
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

request.interceptors.response.use(
  (response) => {
    window.response = response

    if (response.status === 200) {
      return response.data
    }

    return Promise.reject(response)
  },
  (error) => {
    let resp = JSON.parse(error.request.response)
    if (resp.code === 200) {
      window.localStorage.removeItem('token')
      window.localStorage.removeItem('userInfo')
      return resp
    }
    Vue.prototype.$mmToast(error.response ? error.response.data.message : error.message)
    return error
  }
)

export default request
